import { paymentMethods } from '~/App/config/paymentMethods';

export const buildSchema = () => ({
  'productOptions.product.price': {
    presence: {
      allowEmpty: false,
      message: '^Ange ett belopp'
    },
    numericality: {
      greaterThan: 49,
      lessThanOrEqualTo: 999999,
      message: '^Minsta belopp är 50 kr'
    }
  },
  'productOptions.customerContact.email': {
    validateEmail: (_, { paymentMethod }) =>
      paymentMethod.id !== paymentMethods.klarnaPayments
  },
  'productOptions.customerContact.ssn': {
    validateSsn: (value, { paymentMethod, customerContactType }) =>
      paymentMethod.id === paymentMethods.klarnaPayments
        ? false
        : customerContactType === 'automatic' ||
          paymentMethod.id === paymentMethods.bankID ||
          paymentMethod.id === paymentMethods.autoGiroBankId,
    validateLegalAge: (value, { paymentMethod, customerContactType }) =>
      paymentMethod.id === paymentMethods.klarnaPayments
        ? false
        : customerContactType === 'automatic' ||
          paymentMethod.id === paymentMethods.bankID ||
          paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'productOptions.customerContact.lastName': {
    validateLastName: (value, { customerContactType }) =>
      customerContactType === 'manual'
  },
  'productOptions.customerContact.firstName': {
    validateFirstName: (value, { customerContactType }) =>
      customerContactType === 'manual'
  },
  'productOptions.customerContact.addressZip': {
    validateZipCode: (value, { customerContactType }) =>
      customerContactType === 'manual'
  },
  'productOptions.customerContact.addressCity': {
    validateCity: (value, { customerContactType }) =>
      customerContactType === 'manual'
  },
  'productOptions.customerContact.addressStreet': {
    validateStreetName: (value, { customerContactType }) =>
      customerContactType === 'manual'
  },
  'klarna.isReady': {
    inclusion: (_, { paymentMethod }) => {
      if (paymentMethod.id === paymentMethods.klarnaPayments) {
        return {
          within: [true],
          message: '^Klarna är inte redo'
        };
      }

      return false;
    }
  },
  'mobileBankId.bank': {
    validateBank: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.bankID ||
      paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'mobileBankId.accountNumber': {
    validateAccountNumber: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.bankID ||
      paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'mobileBankId.clearingNumber': {
    validateClearingNumber: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.bankID ||
      paymentMethod.id === paymentMethods.autoGiroBankId
  },
  'directDebit.deliverPaper': {
    validateDeliverPaper: (value, { paymentMethod }) =>
      paymentMethod.id === paymentMethods.autoGiroSlip
  }
});
